<div class="location-cell">
  <img
    [ngClass]="{
      'w-9 h-6': size() === 'base',
      'w-6 h-[16px]': size() === 'sm'
    }"
    [class.hidden]="!countryIso2()"
    [src]="
      countryIso2()
        ? 'https://flagcdn.com/w80/' +
          countryIso2().toLowerCase() +
          '.png'
        : null
    "
    alt=""
    (error)="onFlagError($event)"
  />

  <div class="location-text">
    @if (countryName()) {
      <span class="country">{{ countryName() }}</span>
    }
    @if (stateName()) {
      <span class="text-gray-500 text-xs!">{{ stateName() }}</span>
    }
  </div>
</div>